import React , { useEffect , useState } from 'react'
import { Avatar, Typography } from '@mui/material'
import { Box } from '@mui/system'
import { convertToPersianNumber } from 'utils'
import avatar from 'assets/theme/components/avatar'

let URL;
if (process.env.NODE_ENV === "production") {
    URL = `${process.env.REACT_APP_PRODUCTION_API_URL}`;
} else {
    URL = `${process.env.REACT_APP_DEVELOPMENT_API_URL}`;
}

export const UserProfile = ({infoUser}) => {

    return (
        <Box sx={{ flexDirection: 'row', display: 'flex', background: '#fff' }}>

            <Avatar src={infoUser?.avatar ? `${URL}/api/v1/${infoUser.avatar}` : undefined} sx={{ filter: 'drop-shadow(0px 21px 19px rgba(5, 198, 197, 0.17))', width: '48px', height: '48px' }} />

            <Box sx={{ display: 'flex', flexDirection: 'column', mx: 1.5 }}>
                <Typography fontSize={14} gutterBottom fontWeight={'bold'}>{infoUser?.fullName}</Typography>
                <Typography fontSize={13} color='grey.700'>{convertToPersianNumber(infoUser?.token)}  تومان</Typography>
            </Box>

        </Box>
    )
}
